import { faUnlock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    FormText
} from 'reactstrap';
import { ButtonWithConfirmation } from '../../common/ButtonWithConfirmation';
import { SysAdminSection } from '../../common/Section';
import { isSysAdminSelector } from '../../System/selectors';
import { userAdminLoad, userAdminMergeBets, userAdminToggleR1Moderator, userAdminSetMergeBetsCount } from './actions';
import { userAdminProfileSelector, userAdminMergeBetsCountSelector } from './selectors';

interface Props {
    userId: string;
}

export const UserAdmin: FC<Props> = props => {
    const isSysAdmin = useSelector(isSysAdminSelector);

    const [showSysAdminDialog, setShowSysAdminDialog] = React.useState(false);
    const [mergeBetsSrcUser, setMergeBetsSrcUser] = useState('');

    const dispatch = useDispatch();

    const profile = useSelector(userAdminProfileSelector);
    const mergeBetsCount = useSelector(userAdminMergeBetsCountSelector);

    useEffect(() => {
        if (showSysAdminDialog && isSysAdmin) {
            dispatch(userAdminLoad(props.userId));
            dispatch(userAdminSetMergeBetsCount(''));
        }
    }, [dispatch, props.userId, showSysAdminDialog, isSysAdmin]);

    if (!isSysAdmin) {
        return null;
    }
    if (!showSysAdminDialog) {
        return (
            <Button color="link" onClick={() => setShowSysAdminDialog(true)}>
                <FontAwesomeIcon icon={faUnlock} className="text-danger" />
            </Button>
        );
    }
    return (
        <>
            <Modal isOpen={showSysAdminDialog} toggle={() => setShowSysAdminDialog(!showSysAdminDialog)} size="xl">
                <ModalHeader>
                    <span className="text-danger">User-Administration</span>
                </ModalHeader>
                <ModalBody>
                    {isSysAdmin && profile && (
                        <SysAdminSection subtitle={`User '${profile.name}' [${profile.id}]`}>
                            <Form>
                                <Row>
                                    <Col>
                                        <Form >
                                            <FormGroup check={true}>
                                                <Label check={true} className="me-3">
                                                    RadioEins Moderator
                                                </Label>
                                                <Input type="checkbox" name="infoMails" checked={profile.r1Moderator} />
                                            </FormGroup>
                                            <ButtonWithConfirmation
                                                message={`Sind Sie sicher, dass sie das Moderator-Flag von User '${profile.name}' ändern wollen?`}
                                                title="RadioEins Moderator"
                                                className="ms-4"
                                                onOK={() => dispatch(userAdminToggleR1Moderator(profile.id))}
                                            >
                                                Toggle
                                            </ButtonWithConfirmation>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <hr />
                                </Row>
                                <Row>
                                    <Col>
                                        <Form >
                                            <FormGroup inline={true}>
                                                <Label className="me-3">Tipps von User hinzufügen</Label>
                                                <Input
                                                    name="mergeBetsSrcUser"
                                                    placeholder="Username"
                                                    value={mergeBetsSrcUser}
                                                    onChange={e => setMergeBetsSrcUser(e.currentTarget.value)}
                                                />
                                                {mergeBetsCount &&
                                                <FormText className="mx-2" inline={true}>{mergeBetsCount} hinzugefügt</FormText>
}
                                            </FormGroup>
                                            <ButtonWithConfirmation
                                                title="Tipps hinzufügen"
                                                message={`Sind Sie sicher, dass Sie die Tipps von '${mergeBetsSrcUser}' zum User '${profile.name}' kopieren wollen?`}
                                                className="ms-4"
                                                onOK={() =>
                                                    dispatch(
                                                        userAdminMergeBets({
                                                            destUserId: profile.id,
                                                            srcUserName: mergeBetsSrcUser
                                                        })
                                                    )
                                                }
                                            >
                                                Tipps hinzufügen
                                            </ButtonWithConfirmation>
                                        </Form>
                                    </Col>
                                </Row>
                            </Form>
                        </SysAdminSection>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={() => setShowSysAdminDialog(!showSysAdminDialog)}>
                        Schließen
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
